import { FormsService } from "./../../../services/forms/forms.service";
import { put } from "@redux-saga/core/effects";

import { undo } from "./../../../helpers/undoable";
import { ChangePagesViewModeRequestActionType } from "./../types";

export function* updatePagesViewModeSaga(action: ChangePagesViewModeRequestActionType) {
    const {
        payload: { isVerticalView },
    } = action;
    try {
        yield FormsService.updateFormComponent({ data: [{ isVerticalView }] });
    } catch (error) {
        yield put(undo(action));
        // yield put(Handle Error);
    }
}
